/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRadiusTopRight = createReactComponent("outline", "radius-top-right", "IconRadiusTopRight", [["path", { "d": "M5 5h6a8 8 0 0 1 8 8v6", "key": "svg-0" }]]);

export { IconRadiusTopRight as default };
//# sourceMappingURL=IconRadiusTopRight.mjs.map
